function o(t) {
  return t.ok || Math.floor(t.status / 100) === 4;
}
export {
  o as isOkOr4xx
};
